export type Spacing = Record<string, string>;

export const spacing: Spacing = {
  '0': '0',
  '1': '4px',
  '2': '8px',
  '3': '12px',
  '4': '16px',
  '5': '20px',
  '6': '24px',
  '7': '32px',
  '8': '40px',
  '9': '56px',
  '10': '64px',
  '11': '104px',
};
